import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { IResult } from '../../utils/common/types';

type State = {
  data: IResult[];
};

type Actions = {
  remove: (id: string) => void;
  add: (edit: IResult) => void;
  addOrEdit: (edit: IResult) => void;
  edit: (id: string, text: string) => void;
};

const initialState = {
  data: [],
};

export const useEditorRecentStore = create<State & Actions>()(
  persist(
    (set, get) => ({
      ...initialState,
      add: (edit) => {
        set(() => ({
          data: [...get().data, edit],
        }));
      },
      edit: (id, text) => {
        set(() => ({
          data: get().data.map((edit) => (edit.id === id ? { ...edit, result: text } : edit)),
        }));
      },
      addOrEdit: (edit) => {
        const exists = get().data.find((e) => e.id === edit.id);

        if (exists) {
          get().edit(edit.id, edit.result);
        } else {
          get().add(edit);
        }
      },
      remove: (id) => {
        set(() => ({
          data: get().data.filter((edit) => edit.id !== id),
        }));
      },
    }),
    { name: 'playground-editor-recents' },
  ),
);
